import React from 'react';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Markdown from 'components/commercetools-ui/organisms/markdown';

const SectionWithHeadingAndDescription = (props: any) => {
    const { content } = props;
    //console.log('SectionWithHeadingAndDescription', content)

    return (
        <div className={`${content.additional_css ?? ''}`}>
        <div className="">
        <div className={`w-[min(100%,47rem)] 2xl:text-40 xl:text-30 text-24 m-auto title font-medium leading-10 text-primary-black lg:border-none pt-40 pb-12 2xl:pt-80 2xl:pb-12 `}>
          {content.title}
          </div>
        <Markdown
          className= {`${content.description.includes('<img') ? 'w-[min(100%,47rem)] m-auto' : ''}text-[#333333] mardown-container font-normal [&>p]:pt-12  ![&>figure>div>figcaption]:text-left 
          [&>p]:w-[min(100%,47rem)] [&>ul]:w-[min(100%,47rem)] [&>ul]:m-auto [&>ol]:w-[min(100%,47rem)] [&>ol]:m-auto [&>figure>div>figcaption]:w-[min(100%,47rem)]  [&>ul>li] [&>figure>div>figcaption]:m-auto [&>p]:m-auto [&>ul]:list-disc [&>ul>li]:my-10  [&>ul>li>p>a]:!text-[#337ab7] [&>p>a]:!text-[#337ab7] [&>a]:!text-[#337ab7] text-14 md:text-16 2xl:text-18`}
          markdown={content.description}
        />
        </div>
      </div>
);
};

export default SectionWithHeadingAndDescription;